/**
 * Reject a password that is the same as the username, or close to it.
 * Letters only after a small lookalike fold, so "Sankar123!" and "J0h@n"
 * match the username "sankar" / "johan".
 */

const LOOKALIKE = {
  '@': 'a',
  '4': 'a',
  '8': 'b',
  '3': 'e',
  '6': 'g',
  '1': 'i',
  '!': 'i',
  '|': 'i',
  '0': 'o',
  '5': 's',
  '$': 's',
  '7': 't',
  '+': 't'
}

export const PASSWORD_USERNAME_SIMILAR_MESSAGE =
  'Password cannot be the same as or similar to the username'

export function foldIdentity(value) {
  const raw = String(value || '').toLowerCase()
  let out = ''
  for (const ch of raw) {
    if (LOOKALIKE[ch]) out += LOOKALIKE[ch]
    else if (ch >= 'a' && ch <= 'z') out += ch
  }
  return out
}

function levenshtein(a, b) {
  const rows = a.length + 1
  const cols = b.length + 1
  const grid = Array.from({ length: rows }, () => new Array(cols).fill(0))
  for (let i = 0; i < rows; i++) grid[i][0] = i
  for (let j = 0; j < cols; j++) grid[0][j] = j
  for (let i = 1; i < rows; i++) {
    for (let j = 1; j < cols; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      grid[i][j] = Math.min(
        grid[i - 1][j] + 1,
        grid[i][j - 1] + 1,
        grid[i - 1][j - 1] + cost
      )
    }
  }
  return grid[a.length][b.length]
}

export function passwordTooSimilarToUsername(password, username) {
  const userRaw = String(username || '').trim().toLowerCase()
  const passRaw = String(password || '').trim().toLowerCase()
  if (!userRaw || !passRaw) return null
  if (userRaw === passRaw) return PASSWORD_USERNAME_SIMILAR_MESSAGE

  const user = foldIdentity(username)
  const pass = foldIdentity(password).slice(0, 128)
  if (!user || !pass) return null
  if (pass === user) return PASSWORD_USERNAME_SIMILAR_MESSAGE

  if (user.length >= 3 && pass.length >= 3 && (pass.includes(user) || user.includes(pass))) {
    return PASSWORD_USERNAME_SIMILAR_MESSAGE
  }

  const minLen = Math.min(user.length, pass.length)
  const maxLen = Math.max(user.length, pass.length)
  if (minLen >= 4 && maxLen - minLen <= 2) {
    const limit = minLen >= 8 ? 2 : 1
    if (levenshtein(user, pass) <= limit) return PASSWORD_USERNAME_SIMILAR_MESSAGE
  }

  return null
}
